import type { CSSProperties } from "react";

function luminance(rgb: number[]): number {
  const channels = rgb.map((channel) => {
    const value = channel / 255;
    return value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
  });
  return channels[0] * 0.2126 + channels[1] * 0.7152 + channels[2] * 0.0722;
}

// Preserve the configured accent; derive a darker shade for text on white.
export function retailTheme(primaryColor: string): CSSProperties {
  const accent = /^#[0-9a-f]{6}$/i.test(primaryColor)
    ? primaryColor
    : "#252a30";
  const rgb = [1, 3, 5].map((offset) =>
    parseInt(accent.slice(offset, offset + 2), 16),
  );
  let textRgb = [...rgb];
  while (luminance(textRgb) > 0.17) {
    textRgb = textRgb.map((value) => Math.floor(value * 0.85));
  }
  return {
    "--retail-accent": accent,
    "--retail-on-accent": luminance(rgb) > 0.179 ? "#000000" : "#ffffff",
    "--retail-accent-text": `#${textRgb.map((value) => value.toString(16).padStart(2, "0")).join("")}`,
  } as CSSProperties;
}
